export const GST_RATE = 0.1;
export const GST_RATE_PERCENT = 10;
export const GST_RATE_LABEL = `GST (${GST_RATE_PERCENT}%)`;

export const calculateGST = (subtotal: number): number => subtotal * GST_RATE;
export const calculateTotalWithGST = (subtotal: number): number => subtotal + calculateGST(subtotal);
